import React, { useState } from "react";
import { Play } from "lucide-react";
import { ImageWithFallback } from "./ImageWithFallback";

// A photo, or a video that is only downloaded once the guest taps play.
export const MediaTile = ({ item, alt, className = "", testid }) => {
  const [playing, setPlaying] = useState(false);

  if (item?.type !== "video") {
    return <ImageWithFallback src={item?.url} alt={alt} className={className} testid={testid} />;
  }

  if (!playing) {
    return (
      <button
        type="button"
        onClick={() => setPlaying(true)}
        aria-label={`Play video — ${alt}`}
        data-testid={testid ? `${testid}-play` : undefined}
        className={`relative w-full bg-[#E6E3DD] flex items-center justify-center ${className}`}
      >
        <span className="inline-flex items-center gap-2 rounded-full bg-white/90 px-4 py-2.5 text-sm font-semibold text-ink shadow-sm">
          <Play className="w-4 h-4" aria-hidden="true" /> Play video
        </span>
      </button>
    );
  }

  return (
    <video
      src={item.url}
      controls
      autoPlay
      playsInline
      preload="none"
      data-testid={testid}
      className={`w-full bg-black object-contain ${className}`}
    />
  );
};

export default MediaTile;
